<template>
  <field-frame :field="field" :show-optional="showOptional">
    <!-- 旧旧版踏襲 (RenderQuestionnaire.vue:344-360): padding-top で動的アスペクト比、 iframe は absolute で全面に -->
    <div
      class="relative w-full bg-q4cl-surface rounded-q4cl overflow-hidden border border-q4cl-border"
      :style="{ paddingTop: field.height || '60%' }"
    >
      <iframe
        v-if="field.src"
        :src="previewSrc"
        class="absolute inset-0 w-full h-full"
        :title="field.dispname || 'embed'"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
      <div v-else class="absolute inset-0 flex items-center justify-center text-sm text-q4cl-muted">{{ $t('埋め込み URL が設定されていません') }}</div>
    </div>
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
export default {
  name: 'EmbedField',
  components: {
    'field-frame': FieldFrame
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    // 旧旧版踏襲 (RenderQuestionnaire.vue:814-822 makePreviewUrlOfGoogleDoc):
    // Google ドキュメント / プレゼンテーションの「共有 URL」 が来たら埋め込み用 URL に変換
    const previewSrc = Vue.computed(() => {
      const src = props.field.src || '';
      if (!src) return '';
      if (/\/(docs|drive)\.google\.com\/presentation\//.test(src)) {
        return src.replace(/\?.+$/, '').replace(/\/[a-zA-Z]+$/, '/embed');
      }
      if (/\/(docs|drive)\.google\.com\//.test(src)) {
        return src.replace(/\?.+$/, '').replace(/\/[a-zA-Z]+$/, '/preview');
      }
      return src;
    });
    return { previewSrc };
  }
};
</script>
